module.exports = __webpack_public_path__ + "static/media/1569521842449995167851.20b961c1.jpg";